import React from "react";
import { Cpu, ChevronRight, Download } from "lucide-react";
import { LLM_MODEL_OPTIONS, RETRIEVAL_OPTIONS } from "../../constants";
import { ENGINE_OPTIONS } from "../../OcrEngineModal";
import { SX } from "../studioTokens";

/* The old workspace's Pipeline Settings popover, adapted for a draft: engine picks
   open the shared OcrEngineModal; engine/model persist via PATCH /settings/;
   retrieval is held client-side until save. Slug shows only once a slug exists. */
const PipelineSettings = ({ config, onConfigChange, onOpenEngineModal, slug, onExportJson }) => {
  const engineLabel = ENGINE_OPTIONS.find((o) => o.value === config.engine)?.label || "Select Engine";
  const engineDesc = ENGINE_OPTIONS.find((o) => o.value === config.engine)?.shortDesc || "";

  const Lbl = ({ title, hint }) => (
    <div className="mb-1">
      <div className="text-[12.5px] font-semibold text-[#1A1A1A]">{title}</div>
      <div className="text-[11.5px] text-[#8A8A90] mt-px">{hint}</div>
    </div>
  );
  const select = `${SX.input} !py-2 !text-[12.5px] font-semibold cursor-pointer`;

  return (
    <div className={`absolute top-[calc(100%+8px)] right-0 w-[340px] p-[18px] z-[200] flex flex-col gap-4 text-left ${SX.popover}`}>
      <div className="text-[11px] font-semibold uppercase tracking-[0.06em] text-[#8A8A90]">Pipeline Settings</div>

      <div>
        <Lbl title="Extraction Engine" hint="How the document is read before AI processing" />
        <button
          className="w-full mt-1 px-3 py-2.5 border-[1.5px] border-[#E9D2E6] rounded-[10px] bg-[#FBF5FA] cursor-pointer flex items-center gap-2 text-left flex-wrap hover:border-[#A04A97] transition-colors"
          onClick={onOpenEngineModal}
        >
          <Cpu size={14} className="text-[#893F82]" />
          <span className="text-[13.5px] font-semibold text-[#1A1A1A]">{engineLabel}</span>
          <ChevronRight size={13} className="ml-auto text-[#8A8A90] flex-shrink-0" />
          {engineDesc && <span className="w-full text-[11.5px] text-[#52525B] leading-[1.5] mt-1">{engineDesc}</span>}
        </button>
      </div>

      <div>
        <Lbl title="AI Model" hint="Model used to extract the fields" />
        <select className={select} value={config.model} onChange={(e) => onConfigChange("model", e.target.value)}>
          {LLM_MODEL_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>

      <div>
        <Lbl title="Retrieval Mode" hint="How relevant sections are found in long documents" />
        <select className={select} value={config.retrieval} onChange={(e) => onConfigChange("retrieval", e.target.value)}>
          {RETRIEVAL_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>

      {slug && (
        <div className="pt-3 border-t border-[#ECE9EE]">
          <Lbl title="Template Slug" hint="Used in the universal extract API URL" />
          <code className="block mt-1 px-2.5 py-2 rounded-lg bg-[#FBF5FA] text-[#893F82] text-[12px] font-mono break-all">{slug}</code>
        </div>
      )}

      <div className="pt-3 border-t border-[#ECE9EE]">
        <Lbl title="Template JSON" hint="Export the current fields as portable JSON" />
        <button className={`${SX.btn} ${SX.btnGhost} w-full !justify-center mt-1.5`} onClick={onExportJson}>
          <Download size={13} /> Export
        </button>
      </div>
    </div>
  );
};

export default PipelineSettings;
